import { useState, useEffect } from 'react';
import { LocalVideoTrack, RemoteVideoTrack } from 'twilio-video';

import { TrackEvents } from 'screens/TelehealthScreen/utils/enums';
import { saveTelehealthLog } from '../../utils/helpers';

type TrackType = RemoteVideoTrack | LocalVideoTrack | undefined | null;

// The 'switchedOff' event is emitted when there is not enough bandwidth to support
// a track. See: https://www.twilio.com/docs/video/tutorials/using-bandwidth-profile-api#understanding-track-switch-offs

export default function useIsTrackSwitchedOff(track: TrackType) {
  const [isSwitchedOff, setIsSwitchedOff] = useState(track && track.isSwitchedOff);

  useEffect(() => {
    // Reset the value if the 'track' variable changes
    setIsSwitchedOff(track && track.isSwitchedOff);

    if (track) {
      const handleSwitchedOff = () => setIsSwitchedOff(true);
      const handleSwitchedOn = () => setIsSwitchedOff(false);

      track.on(TrackEvents.SwitchedOff, handleSwitchedOff);
      track.on(TrackEvents.SwitchedOn, handleSwitchedOn);
      return () => {
        track.off(TrackEvents.SwitchedOff, handleSwitchedOff);
        track.off(TrackEvents.SwitchedOn, handleSwitchedOn);
      };
    }
  }, [track]);

  useEffect(() => {
    saveTelehealthLog('Patient/Guest - Track is swiched on/off', { track, isSwitchedOff });
  }, [track, isSwitchedOff]);

  return !!isSwitchedOff;
}
